module.exports = __webpack_public_path__ + "static/media/RRD4-BG3.745074bc.jpg";